import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './containers/app';
import LastPostPage from './components/last-post-page';
import CategoriesLink from '../app/containers/categories-link';
import CategoryMobileHeader from '../app/containers/category-mobile-header';
import CategoryDesktopHeader from '../app/containers/category-desktop-header';
import NotFoundPage from '../app/containers/error-page/not-found-page';
import ServerErrorPage from '../app/containers/error-page/server-error-page';
import PostEditorPageOrModal from '../app/containers/post-editor-page-or-modal';
import forMobileOnly from '../app/hoc/for-mobile-only';
import { getConfig } from '../app/services/config';
import { PostRoutes } from '../app/post-routes';
// DANGER!!! New routes can only be 4 chars length or shorter!
// If you are lucky you can take route from black listed slugs in - communities-node-server/app/services/slug-service.js

// eslint-disable-next-line
export default (clientConfig = getConfig()) => (
  <Route path="/" name="Wix Social Blog" component={App}>
    <Route
      path="404"
      components={{ main: NotFoundPage, mobileHeader: CategoryMobileHeader, desktopHeader: CategoryDesktopHeader }}
    />
    <Route
      path="500"
      components={{ main: ServerErrorPage, mobileHeader: CategoryMobileHeader, desktopHeader: CategoryDesktopHeader }}
    />
    <Route
      path="create-post"
      name="Create Post"
      components={{
        main: PostEditorPageOrModal,
        desktopHeader: CategoryDesktopHeader,
      }}
    />
    {PostRoutes}
    <IndexRoute
      components={{
        main: clientConfig.isInEditor || clientConfig.isInPreview ? LastPostPage : NotFoundPage,
        mobileHeader: CategoryMobileHeader,
        mobileMenu: forMobileOnly(CategoriesLink),
        desktopHeader: CategoryDesktopHeader,
      }}
    />
    <Route
      path="*"
      components={{ main: NotFoundPage, mobileHeader: CategoryMobileHeader, desktopHeader: CategoryDesktopHeader }}
    />
  </Route>
);
